import React, {Component} from 'react';

import ToggleInput from "../../../../components/ToggleInput/toggleInput";

export default class TerminalView extends Component {

    render() {

        let terminal = this.props.item;
        if(!terminal){return <div />}

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{terminal.name}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Código</label>
                        <p className={"field-p"}>{terminal.code}</p>
                    </div>
                    <div className={"col s12 input-field"}>
                        <ToggleInput
                            selected={terminal.active}
                            name={'¿Producto activo?'} />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(terminal, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/TerminalView.js